import { createRoot } from 'react-dom/client'
import App from './components/app'

global.Giphy.renderHeader = (el, data) => {
    const root = createRoot(el)

    root.render(<App {...data} />)
    if (module.hot) {
        module.hot.accept('./components/app', () => {
            const NextApp = require('./components/app').default
            root.render(<NextApp {...data} />)
        })
    }
}
